"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var session_1 = require("./session");
/* initialize bugsnag */
var bugsnag_js_1 = __importDefault(require("bugsnag-js"));
var anyWindow = window;
var bugSnagClient = bugsnag_js_1.default({
    apiKey: "21447fd99eb5b20219b267eb1334f7ed",
    metaData: {
        domain: anyWindow.measuredApp && anyWindow.measuredApp.shopifyDomain,
        location: window.location.href,
        sessionKey: session_1.getSessionKey(),
        browserKey: session_1.getBrowserKey(),
    },
    autoNotify: false,
    releaseStage: process.env.RELEASE_STAGE,
    appVersion: process.env.SHA_TAG,
    notifyReleaseStages: ["production", "staging"],
});
var bugsnag_react_1 = __importDefault(require("bugsnag-react"));
var ErrorBoundary = bugSnagClient.use(bugsnag_react_1.default(react_1.default));
require("whendefined");
require("../styles/storefront.scss");
var images_1 = require("./state/images");
var measurements_gql_1 = require("./state/measurements.gql");
var redux_1 = require("redux");
var graphic_1 = require("../shared/models/graphic");
var size_chart_1 = require("../shared/models/size_chart");
var MeasuredAppImageSlider_1 = __importDefault(require("./components/MeasuredAppImageSlider"));
var MeasuredAppSizeChart_1 = __importDefault(require("./components/MeasuredAppSizeChart"));
var react_redux_1 = require("react-redux");
var react_dom_1 = __importDefault(require("react-dom"));
var lodash_find_1 = __importDefault(require("lodash.find"));
var lodash_findindex_1 = __importDefault(require("lodash.findindex"));
var logging_gql_1 = require("./logging.gql");
var measurement_unit_1 = require("../shared/models/measurement_unit");
var url_1 = require("../shared/util/url");
var Annotations_1 = require("./components/Annotations");
var ImageSlider_1 = require("./components/ImageSlider");
var MeasuredAppRunner = /** @class */ (function () {
    function MeasuredAppRunner(sliderRoot, popupRoot, secondarySliderRoots) {
        var _this = this;
        this.preloadState = function () {
            var windowProduct = (anyWindow.measuredApp && anyWindow.measuredApp.product);
            var windowOptions = (anyWindow.measuredApp && anyWindow.measuredApp.options);
            var windowImages = (anyWindow.measuredApp && anyWindow.measuredApp.images);
            var images = _this.extractImageState(windowProduct, windowImages);
            var measurements = _this.extractMeasurementState(windowProduct, windowOptions);
            return { images: images, measurements: measurements };
        };
        this.extractImageState = function (productPayload, imagesPayload) {
            var shopifyProductId = productPayload.id && productPayload.id.toString();
            var imageURLs = productPayload.images.map(_this.shimHTTPS);
            var featuredImageURL = _this.shimHTTPS(productPayload.featured_image);
            var featuredImageIndex = Math.max(imageURLs.indexOf(featuredImageURL || ""), 0);
            var imageVariantIdsMap = {};
            var variants = productPayload.variants;
            variants.forEach(function (variant) {
                var featuredVariantImage = variant.featuredImage;
                if (featuredVariantImage && featuredVariantImage.id) {
                    var imgSrc = featuredVariantImage.src;
                    var variantIds = imageVariantIdsMap[imgSrc] || [];
                    var newVariantIds = variantIds.concat([variant.id.toString()]);
                    imageVariantIdsMap[imgSrc] = newVariantIds;
                }
            });
            var images = imagesPayload.map(function (image) {
                var shopifyImageId = image.id.toString();
                var mainURL = _this.shimHTTPS(image.src);
                var associatedVariantIds = image.variants.map(function (variant) { return variant.id.toString(); });
                var width = image.width;
                var height = image.height;
                var srcSet = image.srcSet.map(function (set) { return ({ url: _this.shimHTTPS(set[0]), width: set[1] }); });
                var castedImage = {
                    shopifyImageId: shopifyImageId,
                    mainURL: mainURL,
                    associatedVariantIds: associatedVariantIds,
                    srcSet: srcSet,
                    shopifyWidth: width,
                    shopifyHeight: height,
                };
                return castedImage;
            });
            // override the featured image if this exists
            var urlVariant = url_1.getURLParameter("variant", window.location.href);
            if (urlVariant) {
                var urlVariantIndex = lodash_findindex_1.default(images, function (image) {
                    return image.associatedVariantIds.indexOf(urlVariant) >= 0;
                });
                if (urlVariantIndex >= 0) {
                    featuredImageIndex = urlVariantIndex;
                }
            }
            return { shopifyProductId: shopifyProductId, images: images, featuredImageIndex: featuredImageIndex };
        };
        this.extractMeasurementState = function (productsPayload, optionsPayload) {
            var featuredImageUrl = _this.shimHTTPS(productsPayload.featured_image);
            var variantsPayload = productsPayload.variants;
            // override the featured image if this exists
            var urlVariantId = _this.getUrlVariant(window.location.href);
            if (urlVariantId) {
                var hasVariant = variantsPayload.some(function (variant) {
                    return variant.id.toString() === urlVariantId;
                });
                if (!hasVariant) {
                    urlVariantId = undefined;
                }
            }
            else {
                urlVariantId = undefined;
            }
            var firstOccurrenceOfFeaturedImageURL = lodash_find_1.default((variantsPayload || []), function (variant) {
                var variantImageURL = (variant.featured_image && variant.featured_image.src);
                return featuredImageUrl === variantImageURL;
            });
            var displayVariantId = urlVariantId
                || (firstOccurrenceOfFeaturedImageURL
                    && firstOccurrenceOfFeaturedImageURL.id.toString())
                || productsPayload.variants
                    && productsPayload.variants[0]
                    && productsPayload.variants[0].id.toString();
            var optionsToVariantId = {};
            variantsPayload.forEach(function (variant) {
                var hash = measurements_gql_1.optionsHash(variant.options);
                var variantId = variant.id.toString();
                optionsToVariantId[hash] = variantId;
            });
            var optionChoices = {};
            optionsPayload.forEach(function (option) {
                optionChoices[option.name] = option.values || [];
            });
            var defaultOptions = (firstOccurrenceOfFeaturedImageURL &&
                firstOccurrenceOfFeaturedImageURL.options) ||
                (variantsPayload[0] &&
                    variantsPayload[0].options) ||
                [];
            var optionLabels = optionsPayload.map(function (option) { return option.name; });
            return {
                displayUnit: measurement_unit_1.metric,
                displayVariantId: displayVariantId,
                annotationsDisplay: Annotations_1.AnnotationsDisplay.HIDE,
                graphics: graphic_1.EmptyGraphicCollection,
                canToggleGraphics: false,
                defaultOptions: defaultOptions,
                optionLabels: optionLabels,
                optionsToVariantId: optionsToVariantId,
                optionChoices: optionChoices,
                sizeChart: size_chart_1.EmptySizeChart,
                showSizeChart: false,
                canToggleSizeChart: false,
                measurementsLoaded: false,
                measurementsLoading: false,
                loadingErrors: [],
                trialExpired: false,
            };
        };
        this.run = function () {
            var preloadedState = _this.preloadState();
            // hide any elements
            var hideSelector = anyWindow.measuredApp
                && anyWindow.measuredApp.hideSelector
                || undefined;
            if (hideSelector) {
                var hideElements = Array.prototype.slice.call(document.querySelectorAll(hideSelector));
                hideElements.forEach(function (el) { el.style.display = "none"; });
            }
            var rootReducer = redux_1.combineReducers({
                measurements: measurements_gql_1.reducer,
                images: images_1.reducer,
            });
            var store = redux_1.createStore(rootReducer, preloadedState, redux_1.applyMiddleware(logging_gql_1.loggingMiddleware));
            var previewPositionString = anyWindow.measuredApp
                && anyWindow.measuredApp.previewPosition
                || ImageSlider_1.PreviewPosition.DOWN;
            var previewPosition = ImageSlider_1.PreviewPosition.DOWN;
            switch (previewPositionString) {
                case ImageSlider_1.PreviewPosition.RIGHT:
                    previewPosition = ImageSlider_1.PreviewPosition.RIGHT;
                    break;
                case ImageSlider_1.PreviewPosition.LEFT:
                    previewPosition = ImageSlider_1.PreviewPosition.LEFT;
                    break;
                case ImageSlider_1.PreviewPosition.DOWN:
                default:
                    previewPosition = ImageSlider_1.PreviewPosition.DOWN;
            }
            // unset loading state
            _this.sliderRoot.classList.remove("ma-loading");
            // slider el
            react_dom_1.default.render(react_1.default.createElement(ErrorBoundary, null,
                react_1.default.createElement(react_redux_1.Provider, { store: store },
                    react_1.default.createElement(MeasuredAppImageSlider_1.default, { imagePreviewPosition: previewPosition }))), _this.sliderRoot);
            if (_this.secondarySliderRoots) {
                [].forEach.call(_this.secondarySliderRoots, function (el) {
                    el.classList.remove("ma-loading");
                    react_dom_1.default.render(react_1.default.createElement(ErrorBoundary, null,
                        react_1.default.createElement(react_redux_1.Provider, { store: store },
                            react_1.default.createElement(MeasuredAppImageSlider_1.default, { imagePreviewPosition: previewPosition }))), el);
                });
            }
            // popup el
            if (_this.popupRoot) {
                react_dom_1.default.render(react_1.default.createElement(ErrorBoundary, null,
                    react_1.default.createElement(react_redux_1.Provider, { store: store },
                        react_1.default.createElement(MeasuredAppSizeChart_1.default, null))), _this.popupRoot);
            }
            // set external listeners
            _this.setURLEventHandlers(store);
        };
        this.getUrlVariant = function (url) {
            var variantString = url_1.getURLParameter("variant", url);
            if (variantString) {
                return variantString;
            }
        };
        this.setURLEventHandlers = function (store) {
            ["replaceState", "pushState"].forEach(function (eventType) {
                window.addEventListener(eventType, function (ev) {
                    var url = ev.arguments.url;
                    var variantId = _this.getUrlVariant(url);
                    if (variantId) {
                        store.dispatch({ type: measurements_gql_1.MeasurementActionType.MEASUREMENTS_SHOW_VARIANT, variantId: variantId });
                        var measurementsEnabled = store.getState().measurements.annotationsDisplay === Annotations_1.AnnotationsDisplay.SHOW_MEASUREMENTS;
                        store.dispatch({
                            type: images_1.ImagesActionType.URL_CHANGED,
                            variantId: variantId,
                            measurementsShown: measurementsEnabled,
                        });
                    }
                });
            });
        };
        this.shimHTTPS = function (imgUrl) {
            if (imgUrl.indexOf("http:") === 0) {
                return imgUrl;
            }
            if (imgUrl.indexOf("https:") !== 0) {
                return "https:" + imgUrl;
            }
            return imgUrl;
        };
        this.sliderRoot = sliderRoot;
        this.popupRoot = popupRoot;
        this.secondarySliderRoots = secondarySliderRoots;
    }
    return MeasuredAppRunner;
}());
// check for URL changes to update variant
var pushState = history.pushState.bind(history);
history.pushState = function (data, title, url) {
    var result = pushState(data, title, url);
    var ev = new Event("pushState");
    ev.arguments = { data: data, title: title, url: url };
    window.dispatchEvent(ev);
    return result;
};
var replaceState = history.replaceState.bind(history);
history.replaceState = function (data, title, url) {
    var result = replaceState(data, title, url);
    var ev = new Event("replaceState");
    ev.arguments = { data: data, title: title, url: url };
    window.dispatchEvent(ev);
    return result;
};
(anyWindow).whenDefined((anyWindow), "measuredApp", function () {
    var sliderRoot = document.getElementById("measured-app");
    var popupId = "measured-app-popup";
    var popupRoot = document.getElementById(popupId);
    if (!popupRoot) {
        popupRoot = document.createElement("div");
        popupRoot.setAttribute("id", popupId);
        var html = document.getElementsByTagName("html")[0];
        html.appendChild(popupRoot);
    }
    var secondarySliderRoots = document.getElementsByClassName("measured-app-secondary");
    if (sliderRoot && popupRoot) {
        new MeasuredAppRunner(sliderRoot, popupRoot, secondarySliderRoots).run();
    }
});
